// Pure Job Tracker filter helpers (client-side filtering of healing jobs).

import { jobDisplayStatus } from './healOutcome';
import { toSelection as asList } from './selection';

// 'YYYY-MM-DD' → local-midnight Date for that day (or null).
const localDay = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

/** True when any filter value is set; '' and [] count as unset. */
export function hasActiveFilters(filters) {
  return Object.values(filters || {}).some((v) => (Array.isArray(v) ? v.length > 0 : Boolean(v)));
}

/**
 * Filter jobs. status/retailer/attribute are lists (any-of); created_from/created_to
 * are 'YYYY-MM-DD', inclusive whole days in the viewer's local time zone.
 */
export function filterJobs(jobs, filters = {}) {
  const retailers = asList(filters.retailer);
  const attributes = asList(filters.attribute);
  const statuses = asList(filters.status);
  const from = localDay(filters.created_from);
  const toDay = localDay(filters.created_to);
  const toExclusive = toDay ? new Date(toDay.getFullYear(), toDay.getMonth(), toDay.getDate() + 1) : null;

  return (jobs || []).filter((job) => {
    // DPS-4717: an out-of-scope / false-positive job matches 'out_of_scope' /
    // 'false_positive', not 'completed'.
    if (statuses.length && !statuses.includes(jobDisplayStatus(job))) return false;
    if (retailers.length && !retailers.includes(job.retailer)) return false;
    if (attributes.length && !attributes.includes(job.attribute)) return false;
    if (filters.triggered_by && job.triggered_by !== filters.triggered_by) return false;
    if (filters.page_type && (job.page_type || 'detail') !== filters.page_type) return false;
    if (filters.issue_type && (job.issue_type || 'null-issues') !== filters.issue_type) return false;
    if (from || toExclusive) {
      const created = job.created_at ? new Date(job.created_at) : null;
      if (!created || Number.isNaN(created.getTime())) return false;
      if (from && created < from) return false;
      if (toExclusive && created >= toExclusive) return false;
    }
    return true;
  });
}
